import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { hasMenuAccess } from './planPermissions';
import useAccesosPortal from '../hooks/useAccesosPortal';

/**
 * Deja pasar solo a quien tiene la sección en su plan. Esconder el enlace en el
 * Sidebar no bastaba: escribiendo la URL a mano se entraba igual.
 *
 * Para el plan Curso el permiso depende del grupo (curso_tipo) y del perfil que
 * el administrador le haya puesto a ese grupo, así que hay que esperar a que
 * llegue la configuración antes de decidir: decidir antes dejaría fuera a quien
 * sí tiene acceso.
 */
const RutaConPlan = ({ user, seccion, children }) => {
    const navigate = useNavigate();
    const { grupos, cargando } = useAccesosPortal();

    const plan = String(user?.plan || 'MENOR').trim().toUpperCase();

    // El administrador entra a todo: su lista de permisos es la del menú, no la
    // de las páginas, y no incluye secciones como PAC.
    if (plan === 'ADMI') return children;

    if (cargando) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center"
                style={{ minHeight: '60vh', background: '#f4f6f8' }}>
                <div className="spinner-border mb-3" role="status" style={{ width: '2.5rem', height: '2.5rem', color: '#0f766e' }}>
                    <span className="visually-hidden">Cargando…</span>
                </div>
                <p className="mb-0" style={{ color: '#64748b' }}>Verificando acceso…</p>
            </div>
        );
    }

    if (hasMenuAccess(plan, seccion, user?.curso_tipo, grupos)) return children;

    return (
        <div className="d-flex align-items-center justify-content-center"
            style={{ minHeight: '70vh', background: '#f4f6f8', padding: '24px' }}>
            <div style={{
                maxWidth: '460px',
                width: '100%',
                background: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '32px',
                textAlign: 'center'
            }}>
                <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '10px',
                    background: '#e8f2f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '16px'
                }}>
                    <Lock size={22} color="#0f4f47" />
                </div>

                <h5 style={{ color: '#0f172a', fontWeight: 700, marginBottom: '8px' }}>
                    {seccion} no está incluido en tu plan
                </h5>
                <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '24px' }}>
                    Tu acceso actual no contempla esta sección. Si crees que debería estar
                    disponible, escríbenos y lo revisamos.
                </p>

                <div className="d-flex gap-2 justify-content-center flex-wrap">
                    <button
                        type="button"
                        className="btn"
                        style={{ background: '#0f766e', color: '#ffffff', fontWeight: 600, border: 'none' }}
                        onClick={() => navigate('/')}
                    >
                        Ir al Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RutaConPlan;
